(function () {
  "use strict";

  const PRODUCTS = (window.CAPITAL_DRINKS_PRODUCTS || []).map((product, index) => ({
    ...product,
    index,
    search: normalize([product.title, product.sku, product.category].join(" ")),
  }));

  const DEFAULT_ROWS = 10;
  const SUGGESTION_LIMIT = 7;
  const VAT_RATE = 0.2;
  const DEFAULT_SUGGESTION_TITLES = ["Coke 24x500ml", "Pepsi 24x500m", "Kit Kat 4 Finger 24x47g"];

  const SUPPLIER_PRESETS = {
    Millennium: [
      { title: "Juice Burst Orange Juice 12X500ml", qty: 1 },
      { title: "Juice Burst Apple Juice 12X500ml", qty: 1 },
      { title: "Evian 330MI X24", qty: 1 },
      { title: "Red Bull Sugar Free Energy Cans 250ml x 24", qty: 1 },
      { title: "Lucozade Orange 500Ml X24", qty: 1 },
      { title: "7Up 500Ml X24", qty: 1 },
      { title: "Pepsi 24x500m", qty: 1 },
      { title: "Pepsi Cans 330Ml X24", qty: 1 },
      { title: "Rio Tropical Cans 330Ml X24", qty: 1 },
      { title: "Coke Zero Cans 330Ml X24", qty: 1 },
      { title: "Tango Apple Cans 330Ml X24", qty: 1 },
      { title: "Tango Cherry Sugar Free Cans 24x330ml", qty: 1 },
      { title: "San Pellegrino Aranciata Rossa Red 24 X 330MI Cans", qty: 1 },
      { title: "San Pellegrino Aranciata (Orange) 24 X 330MI Cans", qty: 1 },
      { title: "San Pellegrino Limonata (Lemon) 24 X 330MI Cans", qty: 1 },
      { title: "Oasis Summer Fruits 500Ml X12", qty: 1 },
      { title: "Coke Cans 24 X 330Ml", qty: 1 },
    ],
    Templeman: [
      { title: "Coke Zero 500Ml X24", qty: 72, rate: 12.59 },
      { title: "Coke 24x500ml", qty: 216, rate: 15.59 },
      { title: "Walkers Cheese & Onion Std 32G X32", qty: 10, rate: 13.99 },
      { title: "Yorkie Raisin Std 57G X24", qty: 30, rate: 11.99 },
      { title: "Yorkie Original 57G X24", qty: 30, rate: 11.99 },
      { title: "Fanta Lemon 500Ml X24", qty: 144, rate: 12.59 },
      { title: "Fanta Orange 500Ml X24", qty: 144, rate: 12.59 },
      { title: "Walkers Ready Salted Std X32", qty: 10, rate: 13.99 },
      { title: "Walkers Prawn Cocktail Std 32G X32", qty: 10, rate: 13.99 },
      { title: "Walkers Salt & Vinegar Std 32G X32", qty: 10, rate: 13.99 },
    ],
    Fairfields: [
      { title: "Fairfields Farm Cheese & Onion 36x40g", qty: 1 },
      { title: "Fairfields Farm Lightly Salted 36x40g", qty: 1 },
      { title: "Fairfields Farm Roast Rib of Beef 36x40g", qty: 1 },
      { title: "Fairfields Farm Sea Salt & Aspall Cyder Vinegar 36x40g", qty: 1 },
      { title: "Fairfields Farm Sweet Chilli 36x40g", qty: 1 },
    ],
    Flapjax: [
      { title: "FLAPJACKS 120G IND 30 Yoghurt", qty: 1 },
      { title: "FLAPJACKS 120G IND 30 Choc Chip", qty: 1 },
      { title: "FLAPJACKS 120G IND 30 Cherry & Almond", qty: 1 },
    ],
  };

  const elements = {
    root: document.getElementById("capital-drinks-purchase-order"),
    supplier: document.getElementById("supplier"),
    poDate: document.getElementById("poDate"),
    poNumber: document.getElementById("poNumber"),
    supplierMessage: document.getElementById("supplierMessage"),
    rows: document.getElementById("itemRows"),
    rowTemplate: document.getElementById("itemRowTemplate"),
    addLineButton: document.getElementById("addLineButton"),
    clearFormButton: document.getElementById("clearFormButton"),
    emailButton: document.getElementById("emailButton"),
    emailStatus: document.getElementById("emailStatus"),
    excelButton: document.getElementById("excelButton"),
    pdfButton: document.getElementById("pdfButton"),
    subtotal: document.getElementById("subtotal"),
    vat: document.getElementById("vat"),
    total: document.getElementById("total"),
  };

  initialize();

  function initialize() {
    const today = getLocalDateValue(new Date());
    clearOldDraft();
    elements.poDate.value = today;
    elements.poNumber.value = generateReference();
    elements.supplier.value = "";
    elements.supplierMessage.value = "";
    elements.rows.textContent = "";

    for (let index = 0; index < DEFAULT_ROWS; index += 1) {
      addItemRow();
    }

    bindEvents();
    renumberRows();
    updateTotals();
  }

  function bindEvents() {
    elements.addLineButton.addEventListener("click", () => {
      addItemRow();
      const lastRow = elements.rows.querySelector("tr:last-child .item-search");
      if (lastRow) lastRow.focus();
    });

    elements.clearFormButton.addEventListener("click", () => {
      if (!window.confirm("Clear this purchase order?")) return;
      clearForm();
    });

    elements.excelButton.addEventListener("click", downloadExcel);
    elements.pdfButton.addEventListener("click", downloadPdf);
    if (elements.emailButton) {
      elements.emailButton.addEventListener("click", emailSupplier);
    }
    elements.supplier.addEventListener("change", () => applySupplierPreset(elements.supplier.value));

    elements.rows.addEventListener("input", handleRowInput);
    elements.rows.addEventListener("focusin", handleRowFocus);
    elements.rows.addEventListener("keydown", handleRowKeydown);
    elements.rows.addEventListener("mousedown", handleSuggestionMouseDown);
    elements.rows.addEventListener("click", handleRowClick);
    elements.rows.addEventListener("blur", handleRowBlur, true);

    document.addEventListener("click", (event) => {
      if (!event.target.closest(".autocomplete")) {
        closeAllSuggestions();
      }
    });
  }

  function addItemRow(data = {}) {
    const fragment = elements.rowTemplate.content.cloneNode(true);
    const row = fragment.querySelector("tr");
    const productName = data.product || data.description || "";
    const hasLineContent = Boolean(productName || data.productIndex);
    const qtyValue = hasLineContent ? data.qtyRaw ?? data.qty ?? "" : "";
    const rateValue = hasLineContent ? data.rateRaw ?? formatNumber(data.rate || 0) : "";

    row.dataset.productIndex = data.productIndex ?? "";
    row.querySelector(".item-search").value = productName;
    row.querySelector(".item-search").title = productName;
    row.querySelector(".qty-input").value = qtyValue;
    row.querySelector(".rate-input").value = rateValue;
    row.querySelector(".amount-input").value = hasLineContent ? formatMoney(data.amount || 0) : "";

    elements.rows.appendChild(fragment);
    renumberRows();
    return row;
  }

  function handleRowInput(event) {
    const row = event.target.closest("tr");
    if (!row) return;

    if (event.target.classList.contains("item-search")) {
      clearSelectedProduct(row, event.target.value);
      showSuggestions(row, event.target.value);
    }

    if (
      event.target.classList.contains("qty-input") ||
      event.target.classList.contains("rate-input") ||
      event.target.classList.contains("item-search")
    ) {
      updateRowAmount(row);
      updateTotals();
    }
  }

  function handleRowFocus(event) {
    if (!event.target.classList.contains("item-search")) return;
    const row = event.target.closest("tr");
    showSuggestions(row, event.target.value);
  }

  function handleRowBlur(event) {
    if (!event.target.classList.contains("item-search")) return;
    const row = event.target.closest("tr");
    window.setTimeout(() => {
      maybeSelectExactProduct(row);
      closeSuggestions(row);
    }, 120);
  }

  function handleRowClick(event) {
    if (event.target.classList.contains("item-search")) {
      const row = event.target.closest("tr");
      showSuggestions(row, event.target.value);
      return;
    }

    const deleteButton = event.target.closest(".delete-line");
    if (!deleteButton) return;

    const row = deleteButton.closest("tr");
    if (elements.rows.children.length === 1) {
      clearRow(row);
    } else {
      row.remove();
      renumberRows();
    }

    updateTotals();
  }

  function handleSuggestionMouseDown(event) {
    const option = event.target.closest(".suggestion");
    if (!option) return;
    event.preventDefault();

    const row = option.closest("tr");
    const product = PRODUCTS[Number(option.dataset.productIndex)];
    if (row && product) {
      selectProduct(row, product);
      closeSuggestions(row);
      const quantity = row.querySelector(".qty-input");
      if (quantity) quantity.focus();
    }
  }

  function handleRowKeydown(event) {
    if (!event.target.classList.contains("item-search")) return;
    const row = event.target.closest("tr");
    const suggestionBox = row.querySelector(".suggestions");
    const options = Array.from(suggestionBox.querySelectorAll(".suggestion"));
    if (!options.length || !suggestionBox.classList.contains("open")) return;

    const currentIndex = options.findIndex((option) => option.classList.contains("active"));

    if (event.key === "ArrowDown") {
      event.preventDefault();
      setActiveSuggestion(options, currentIndex < options.length - 1 ? currentIndex + 1 : 0);
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      setActiveSuggestion(options, currentIndex > 0 ? currentIndex - 1 : options.length - 1);
    }

    if (event.key === "Enter") {
      const selected = options[currentIndex] || options[0];
      if (selected) {
        event.preventDefault();
        const product = PRODUCTS[Number(selected.dataset.productIndex)];
        selectProduct(row, product);
        closeSuggestions(row);
      }
    }

    if (event.key === "Escape") {
      closeSuggestions(row);
    }
  }

  function setActiveSuggestion(options, index) {
    options.forEach((option) => option.classList.remove("active"));
    if (options[index]) {
      options[index].classList.add("active");
      options[index].scrollIntoView({ block: "nearest" });
    }
  }

  function showSuggestions(row, query) {
    if (!row) return;
    const suggestionBox = row.querySelector(".suggestions");
    suggestionBox.textContent = "";

    const matches = findProducts(query).slice(0, SUGGESTION_LIMIT);
    if (!matches.length) {
      closeSuggestions(row);
      return;
    }

    matches.forEach((product, index) => {
      const option = document.createElement("button");
      option.type = "button";
      option.className = `suggestion${index === 0 ? " active" : ""}`;
      option.dataset.productIndex = String(product.index);
      option.setAttribute("role", "option");

      const title = document.createElement("span");
      title.className = "suggestion-title";
      title.textContent = product.title;

      const meta = document.createElement("span");
      meta.className = "suggestion-meta";
      meta.textContent = `Unit cost ${formatMoney(product.cost)}`;

      option.append(title, meta);
      suggestionBox.appendChild(option);
    });

    closeAllSuggestions(row);
    suggestionBox.classList.add("open");
  }

  function findProducts(query) {
    const trimmed = normalize(query);
    if (!trimmed) return getDefaultSuggestions();
    const terms = trimmed.split(" ").filter(Boolean);
    return PRODUCTS.filter((product) => terms.every((term) => product.search.includes(term)));
  }

  function getDefaultSuggestions() {
    const defaults = DEFAULT_SUGGESTION_TITLES.map((title) => findProductByTitle(title)).filter(Boolean);
    return defaults.length ? defaults : PRODUCTS.slice(0, SUGGESTION_LIMIT);
  }

  function applySupplierPreset(supplier) {
    elements.rows.textContent = "";
    const presetItems = SUPPLIER_PRESETS[supplier] || [];

    presetItems.forEach((item) => {
      const product = findProductByTitle(item.title);
      const rate = item.rate ?? product?.cost ?? 0;
      addItemRow({
        product: product?.title || item.title,
        productIndex: product ? product.index : "",
        qty: item.qty ?? 1,
        qtyRaw: String(item.qty ?? 1),
        rate,
        rateRaw: formatNumber(rate),
        amount: (item.qty ?? 1) * rate,
      });
    });

    while (elements.rows.children.length < DEFAULT_ROWS) {
      addItemRow();
    }

    renumberRows();
    updateTotals();
  }

  function findProductByTitle(title) {
    const normalizedTitle = normalize(title);
    return PRODUCTS.find((product) => normalize(product.title) === normalizedTitle) || null;
  }

  function selectProduct(row, product) {
    if (!row || !product) return;

    row.dataset.productIndex = String(product.index);
    row.querySelector(".item-search").value = product.title;
    row.querySelector(".item-search").title = product.title;
    row.querySelector(".rate-input").value = formatNumber(product.cost);

    const qtyInput = row.querySelector(".qty-input");
    if (!parseNumber(qtyInput.value)) {
      qtyInput.value = "1";
    }

    updateRowAmount(row);
    updateTotals();
  }

  function maybeSelectExactProduct(row) {
    if (!row) return;
    const input = row.querySelector(".item-search");
    const value = normalize(input.value);
    if (!value) return;

    const product = PRODUCTS.find((item) => normalize(item.title) === value || normalize(item.sku) === value);
    if (product) selectProduct(row, product);
  }

  function clearSelectedProduct(row, typedValue) {
    const selectedIndex = row.dataset.productIndex;
    const selected = selectedIndex !== "" ? PRODUCTS[Number(selectedIndex)] : null;
    if (selected && selected.title === typedValue) return;

    row.dataset.productIndex = "";
    row.querySelector(".item-search").title = typedValue || "";
    row.querySelector(".rate-input").value = typedValue ? "0.00" : "";
  }

  function clearRow(row) {
    row.dataset.productIndex = "";
    row.querySelector(".item-search").value = "";
    row.querySelector(".item-search").title = "";
    row.querySelector(".qty-input").value = "";
    row.querySelector(".rate-input").value = "";
    row.querySelector(".amount-input").value = "";
    closeSuggestions(row);
  }

  function closeSuggestions(row) {
    const suggestionBox = row && row.querySelector(".suggestions");
    if (suggestionBox) suggestionBox.classList.remove("open");
  }

  function closeAllSuggestions(exceptRow) {
    elements.rows.querySelectorAll("tr").forEach((row) => {
      if (row !== exceptRow) closeSuggestions(row);
    });
  }

  function updateRowAmount(row) {
    const itemName = row.querySelector(".item-search").value.trim();
    const qtyValue = row.querySelector(".qty-input").value.trim();
    const rateValue = row.querySelector(".rate-input").value.trim();
    const qty = parseNumber(qtyValue);
    const rate = parseNumber(rateValue);
    if (!itemName && !qtyValue && !rateValue) {
      row.querySelector(".amount-input").value = "";
      return;
    }
    row.querySelector(".amount-input").value = formatMoney(qty * rate);
  }

  function updateTotals() {
    const totals = calculateTotals(getLineItems(false));
    elements.subtotal.textContent = formatMoney(totals.subtotal);
    elements.vat.textContent = formatMoney(totals.vat);
    elements.total.textContent = formatMoney(totals.total);
  }

  function getLineItems(includeBlankRows) {
    return Array.from(elements.rows.querySelectorAll("tr"))
      .map((row, index) => {
        const qtyRaw = row.querySelector(".qty-input").value.trim();
        const rateRaw = row.querySelector(".rate-input").value.trim();
        const product = row.querySelector(".item-search").value.trim();
        const qty = parseNumber(qtyRaw);
        const rate = parseNumber(rateRaw);
        const amount = qty * rate;
        const vatRate = getVatRateForItem(product);
        return {
          number: index + 1,
          product,
          qty,
          qtyRaw,
          rate,
          rateRaw,
          amount,
          vatRate,
          vat: amount * vatRate,
          productIndex: row.dataset.productIndex || "",
        };
      })
      .filter((item) => includeBlankRows || item.product || item.qty || item.rate);
  }

  function getOrderData() {
    const items = getLineItems(false);
    const totals = calculateTotals(items);
    return {
      from: "Capital Drinks UK LTD",
      supplier: elements.supplier.value,
      dateValue: elements.poDate.value,
      date: formatDisplayDate(elements.poDate.value),
      poNumber: elements.poNumber.value.trim(),
      message: elements.supplierMessage.value.trim(),
      items,
      subtotal: totals.subtotal,
      vat: totals.vat,
      total: totals.total,
    };
  }

  function calculateTotals(items) {
    const subtotal = items.reduce((sum, item) => sum + item.amount, 0);
    const vat = items.reduce((sum, item) => sum + item.amount * item.vatRate, 0);
    return {
      subtotal,
      vat,
      total: subtotal + vat,
    };
  }

  function getVatRateForItem(productName) {
    if (elements.supplier.value === "Flapjax" || normalize(productName).includes("flapjack")) {
      return 0;
    }
    return VAT_RATE;
  }

  function clearForm() {
    const today = getLocalDateValue(new Date());
    elements.supplier.value = "";
    elements.poDate.value = today;
    elements.poNumber.value = generateReference();
    elements.supplierMessage.value = "";
    elements.rows.textContent = "";
    for (let index = 0; index < DEFAULT_ROWS; index += 1) {
      addItemRow();
    }
    updateTotals();
  }

  function renumberRows() {
    elements.rows.querySelectorAll("tr").forEach((row, index) => {
      row.querySelector(".line-number").textContent = String(index + 1);
    });
  }

  function downloadExcel() {
    const data = getOrderData();
    const xlsx = buildXlsx(data);
    downloadBlob(xlsx, makeFileName(data, "xlsx"));
  }

  function buildXlsx(data) {
    const rows = data.items.length ? data.items : [{ number: 1, product: "", qty: 0, rate: 0, amount: 0 }];
    const itemStartRow = 7;
    const itemEndRow = itemStartRow + rows.length - 1;
    const summaryStartRow = itemEndRow + 2;
    const lastRow = summaryStartRow + 2;
    const sheetRows = [
      xlsxRow(1, [
        [1, "Purchase Order", 1],
        [4, "Reference", 2],
        [5, data.poNumber, 2],
      ], 28),
      xlsxRow(3, [
        [1, "From", 2],
        [2, data.from, 0],
        [4, "Supplier", 2],
        [5, data.supplier, 0],
      ]),
      xlsxRow(4, [
        [1, "Date", 2],
        [2, data.date, 0],
      ]),
      xlsxRow(6, [
        [1, "#", 3],
        [2, "Item name", 3],
        [3, "Unit cost (GBP)", 3],
        [4, "Quantity", 3],
        [5, "Total per item (GBP)", 3],
      ]),
      ...rows.map((item, index) =>
        xlsxRow(itemStartRow + index, [
          [1, index + 1, 8],
          [2, item.product, 7],
          [3, item.rate, 4],
          [4, item.qty || "", 8],
          [5, item.amount, 4],
        ])
      ),
      xlsxRow(summaryStartRow, [
        [4, "Subtotal", 5],
        [5, data.subtotal, 4],
      ]),
      xlsxRow(summaryStartRow + 1, [
        [4, "VAT", 5],
        [5, data.vat, 4],
      ]),
      xlsxRow(summaryStartRow + 2, [
        [4, "Total", 6],
        [5, data.total, 6],
      ]),
    ].join("");

    const worksheet = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
  <dimension ref="A1:E${lastRow}"/>
  <sheetViews><sheetView workbookViewId="0"><pane ySplit="6" topLeftCell="A7" activePane="bottomLeft" state="frozen"/></sheetView></sheetViews>
  <sheetFormatPr defaultRowHeight="20"/>
  <cols>
    <col min="1" max="1" width="6" customWidth="1"/>
    <col min="2" max="2" width="48" customWidth="1"/>
    <col min="3" max="3" width="16" customWidth="1"/>
    <col min="4" max="4" width="12" customWidth="1"/>
    <col min="5" max="5" width="18" customWidth="1"/>
  </cols>
  <sheetData>${sheetRows}</sheetData>
  <mergeCells count="1"><mergeCell ref="A1:C1"/></mergeCells>
  <pageMargins left="0.5" right="0.5" top="0.75" bottom="0.75" header="0.3" footer="0.3"/>
</worksheet>`;

    const files = [
      ["[Content_Types].xml", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
  <Default Extension="xml" ContentType="application/xml"/>
  <Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/>
  <Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/>
  <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>
  <Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>
  <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>
</Types>`],
      ["_rels/.rels", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>
  <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/>
  <Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/>
</Relationships>`],
      ["docProps/app.xml", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes">
  <Application>Capital Drinks Purchase Order</Application>
</Properties>`],
      ["docProps/core.xml", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
  <dc:title>Purchase Order ${escapeXml(data.poNumber)}</dc:title>
  <dc:creator>Capital Drinks UK LTD</dc:creator>
  <dcterms:created xsi:type="dcterms:W3CDTF">${new Date().toISOString()}</dcterms:created>
</cp:coreProperties>`],
      ["xl/workbook.xml", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
  <sheets><sheet name="Purchase Order" sheetId="1" r:id="rId1"/></sheets>
</workbook>`],
      ["xl/_rels/workbook.xml.rels", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>
  <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>
</Relationships>`],
      ["xl/styles.xml", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
  <fonts count="3">
    <font><sz val="11"/><name val="Arial"/></font>
    <font><b/><sz val="11"/><name val="Arial"/></font>
    <font><b/><sz val="20"/><name val="Arial"/></font>
  </fonts>
  <fills count="3">
    <fill><patternFill patternType="none"/></fill>
    <fill><patternFill patternType="gray125"/></fill>
    <fill><patternFill patternType="solid"><fgColor rgb="FFEDEFF2"/><bgColor indexed="64"/></patternFill></fill>
  </fills>
  <borders count="2">
    <border><left/><right/><top/><bottom/><diagonal/></border>
    <border><left style="thin"><color rgb="FFCFD5DC"/></left><right style="thin"><color rgb="FFCFD5DC"/></right><top style="thin"><color rgb="FFCFD5DC"/></top><bottom style="thin"><color rgb="FFCFD5DC"/></bottom><diagonal/></border>
  </borders>
  <cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>
  <cellXfs count="9">
    <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>
    <xf numFmtId="0" fontId="2" fillId="0" borderId="0" xfId="0" applyFont="1"/>
    <xf numFmtId="0" fontId="1" fillId="0" borderId="0" xfId="0" applyFont="1"/>
    <xf numFmtId="0" fontId="1" fillId="2" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1"><alignment vertical="center"/></xf>
    <xf numFmtId="4" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/>
    <xf numFmtId="0" fontId="1" fillId="0" borderId="1" xfId="0" applyFont="1" applyBorder="1"/>
    <xf numFmtId="4" fontId="1" fillId="0" borderId="1" xfId="0" applyFont="1" applyNumberFormat="1" applyBorder="1"/>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1"><alignment wrapText="1" vertical="top"/></xf>
    <xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1"/>
  </cellXfs>
  <cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>
</styleSheet>`],
      ["xl/worksheets/sheet1.xml", worksheet],
    ];

    return new Blob([buildZip(files)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
  }

  function xlsxRow(rowNumber, cells, height) {
    const heightAttributes = height ? ` ht="${height}" customHeight="1"` : "";
    return `<row r="${rowNumber}"${heightAttributes}>${cells
      .map(([column, value, style]) => xlsxCell(`${xlsxColumnName(column)}${rowNumber}`, value, style))
      .join("")}</row>`;
  }

  function xlsxCell(reference, value, style) {
    const styleAttribute = style ? ` s="${style}"` : "";
    if (typeof value === "number") {
      return `<c r="${reference}"${styleAttribute}><v>${Number.isFinite(value) ? value : 0}</v></c>`;
    }
    if (value === "" || value === null || value === undefined) {
      return `<c r="${reference}"${styleAttribute}/>`;
    }
    return `<c r="${reference}" t="inlineStr"${styleAttribute}><is><t>${escapeXml(value)}</t></is></c>`;
  }

  function xlsxColumnName(columnNumber) {
    let name = "";
    let number = columnNumber;
    while (number > 0) {
      const remainder = (number - 1) % 26;
      name = String.fromCharCode(65 + remainder) + name;
      number = Math.floor((number - remainder) / 26);
    }
    return name;
  }

  function buildZip(files) {
    const encoder = new TextEncoder();
    const localParts = [];
    const centralParts = [];
    let offset = 0;

    files.forEach(([name, content]) => {
      const nameBytes = encoder.encode(name);
      const dataBytes = typeof content === "string" ? encoder.encode(content) : content;
      const checksum = crc32(dataBytes);
      const localHeader = new Uint8Array(30 + nameBytes.length);
      const localView = new DataView(localHeader.buffer);
      writeZipHeader(localView, 0x04034b50, dataBytes.length, checksum, nameBytes.length);
      localHeader.set(nameBytes, 30);
      localParts.push(localHeader, dataBytes);

      const centralHeader = new Uint8Array(46 + nameBytes.length);
      const centralView = new DataView(centralHeader.buffer);
      centralView.setUint32(0, 0x02014b50, true);
      centralView.setUint16(4, 20, true);
      centralView.setUint16(6, 20, true);
      centralView.setUint16(8, 0, true);
      centralView.setUint16(10, 0, true);
      centralView.setUint16(12, 0, true);
      centralView.setUint16(14, 0, true);
      centralView.setUint32(16, checksum, true);
      centralView.setUint32(20, dataBytes.length, true);
      centralView.setUint32(24, dataBytes.length, true);
      centralView.setUint16(28, nameBytes.length, true);
      centralView.setUint16(30, 0, true);
      centralView.setUint16(32, 0, true);
      centralView.setUint16(34, 0, true);
      centralView.setUint16(36, 0, true);
      centralView.setUint32(38, 0, true);
      centralView.setUint32(42, offset, true);
      centralHeader.set(nameBytes, 46);
      centralParts.push(centralHeader);

      offset += localHeader.length + dataBytes.length;
    });

    const centralSize = centralParts.reduce((sum, part) => sum + part.length, 0);
    const endRecord = new Uint8Array(22);
    const endView = new DataView(endRecord.buffer);
    endView.setUint32(0, 0x06054b50, true);
    endView.setUint16(8, files.length, true);
    endView.setUint16(10, files.length, true);
    endView.setUint32(12, centralSize, true);
    endView.setUint32(16, offset, true);

    return concatBytes([...localParts, ...centralParts, endRecord]);
  }

  function writeZipHeader(view, signature, size, checksum, nameLength) {
    view.setUint32(0, signature, true);
    view.setUint16(4, 20, true);
    view.setUint16(6, 0, true);
    view.setUint16(8, 0, true);
    view.setUint16(10, 0, true);
    view.setUint16(12, 0, true);
    view.setUint32(14, checksum, true);
    view.setUint32(18, size, true);
    view.setUint32(22, size, true);
    view.setUint16(26, nameLength, true);
    view.setUint16(28, 0, true);
  }

  function concatBytes(parts) {
    const totalLength = parts.reduce((sum, part) => sum + part.length, 0);
    const output = new Uint8Array(totalLength);
    let offset = 0;
    parts.forEach((part) => {
      output.set(part, offset);
      offset += part.length;
    });
    return output;
  }

  function crc32(bytes) {
    const table = crc32.table || (crc32.table = makeCrcTable());
    let crc = -1;
    for (let index = 0; index < bytes.length; index += 1) {
      crc = (crc >>> 8) ^ table[(crc ^ bytes[index]) & 0xff];
    }
    return (crc ^ -1) >>> 0;
  }

  function makeCrcTable() {
    const table = new Uint32Array(256);
    for (let index = 0; index < 256; index += 1) {
      let value = index;
      for (let bit = 0; bit < 8; bit += 1) {
        value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
      }
      table[index] = value >>> 0;
    }
    return table;
  }

  function downloadPdf() {
    const data = getOrderData();
    const pdf = buildPdf(data);
    downloadBlob(new Blob([pdf], { type: "application/pdf" }), makeFileName(data, "pdf"));
  }

  function emailSupplier() {
    const data = getOrderData();
    const settings = getEmailSettings();
    const supplierEmail = getSupplierEmail(data.supplier, settings);

    if (!data.supplier) {
      setEmailStatus("Choose a supplier first.", true);
      return;
    }

    if (!data.items.length) {
      setEmailStatus("Add at least one item before emailing.", true);
      return;
    }

    if (!settings.webhookUrl) {
      setEmailStatus("Email sender URL is not set in the Shopify section settings.", true);
      return;
    }

    if (!supplierEmail) {
      setEmailStatus(`No email address is set for ${data.supplier}.`, true);
      return;
    }

    const pdf = buildPdf(data);
    const payload = {
      secret: settings.secret,
      to: supplierEmail,
      supplier: data.supplier,
      reference: data.poNumber,
      subject: `Purchase Order ${data.poNumber} - Capital Drinks UK LTD`,
      message: data.message,
      body: buildEmailBody(data),
      filename: makeFileName(data, "pdf"),
      pdfBase64: btoa(pdf),
      order: {
        from: data.from,
        supplier: data.supplier,
        date: data.date,
        reference: data.poNumber,
        subtotal: formatMoney(data.subtotal),
        vat: formatMoney(data.vat),
        total: formatMoney(data.total),
        items: data.items.map((item) => ({
          item: item.product,
          unitCost: formatMoney(item.rate),
          quantity: item.qty,
          lineTotal: formatMoney(item.amount),
        })),
      },
    };

    setEmailStatus("Sending email request...");
    submitEmailPayload(settings.webhookUrl, payload);

    if (elements.emailButton) {
      elements.emailButton.disabled = true;
      window.setTimeout(() => {
        elements.emailButton.disabled = false;
      }, 2500);
    }

    window.setTimeout(() => {
      setEmailStatus(`Email request sent to ${supplierEmail}.`);
    }, 1200);
  }

  function buildEmailBody(data) {
    const itemLines = data.items
      .map((item) => `- ${item.product} | Qty ${item.qty || 0} | Unit ${formatMoney(item.rate)} | Line ${formatMoney(item.amount)}`)
      .join("\n");

    return [
      `Please find purchase order ${data.poNumber} attached.`,
      "",
      `Supplier: ${data.supplier}`,
      `Date: ${data.date}`,
      "",
      "Items:",
      itemLines,
      "",
      `Subtotal: ${formatMoney(data.subtotal)}`,
      `VAT: ${formatMoney(data.vat)}`,
      `Total: ${formatMoney(data.total)}`,
      data.message ? `\nMessage to supplier:\n${data.message}` : "",
    ].join("\n");
  }

  function getEmailSettings() {
    const dataset = elements.root ? elements.root.dataset : {};
    return {
      webhookUrl: (dataset.emailWebhookUrl || "").trim(),
      secret: (dataset.emailSecret || "").trim(),
      emails: {
        Millennium: (dataset.emailMillennium || "").trim(),
        Templeman: (dataset.emailTempleman || "").trim(),
        Fairfields: (dataset.emailFairfields || "").trim(),
        Flapjax: (dataset.emailFlapjax || "").trim(),
        "General Supplier": (dataset.emailGeneralSupplier || "").trim(),
      },
    };
  }

  function getSupplierEmail(supplier, settings) {
    return settings.emails[supplier] || "";
  }

  function submitEmailPayload(webhookUrl, payload) {
    const iframeName = `po-email-frame-${Date.now()}`;
    const iframe = document.createElement("iframe");
    iframe.name = iframeName;
    iframe.style.display = "none";

    const form = document.createElement("form");
    form.method = "POST";
    form.action = webhookUrl;
    form.target = iframeName;
    form.style.display = "none";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "payload";
    input.value = JSON.stringify(payload);

    form.appendChild(input);
    document.body.append(iframe, form);
    form.submit();

    window.setTimeout(() => {
      form.remove();
      iframe.remove();
    }, 10000);
  }

  function setEmailStatus(message, isError) {
    if (!elements.emailStatus) {
      if (isError) window.alert(message);
      return;
    }
    elements.emailStatus.textContent = message;
    elements.emailStatus.style.color = isError ? "#b42318" : "";
  }

  function buildPdf(data) {
    const pageWidth = 595.28;
    const pageHeight = 841.89;
    const margin = 42;
    const bottom = 48;
    const tableRight = pageWidth - margin;
    const pages = [];
    let page = null;
    let y = pageHeight - margin;

    const x = {
      number: margin + 4,
      product: margin + 28,
      rate: 390,
      qty: 455,
      amount: tableRight,
    };

    function newPage(withTableHeader) {
      page = [];
      pages.push(page);
      y = pageHeight - margin;
      if (pages.length > 1) {
        drawCenteredText("Purchase Order continued", pageWidth / 2, y, 12, true);
        y -= 22;
      }
      if (withTableHeader) drawTableHeader();
    }

    function ensureSpace(height, withTableHeader) {
      if (y - height < bottom) newPage(withTableHeader);
    }

    function drawText(text, left, top, size, bold) {
      page.push(`BT /${bold ? "F2" : "F1"} ${size} Tf 1 0 0 1 ${fixed(left)} ${fixed(top)} Tm (${pdfEscape(text)}) Tj ET`);
    }

    function drawRightText(text, right, top, size, bold) {
      drawText(text, right - estimateTextWidth(text, size), top, size, bold);
    }

    function drawCenteredText(text, center, top, size, bold) {
      drawText(text, center - estimateTextWidth(text, size) / 2, top, size, bold);
    }

    function drawLine(left, top, right, bottomY, width) {
      page.push(`${fixed(width || 0.6)} w ${fixed(left)} ${fixed(top)} m ${fixed(right)} ${fixed(bottomY)} l S`);
    }

    function drawFillRect(left, top, width, height, color) {
      page.push(`q ${color} rg ${fixed(left)} ${fixed(top - height)} ${fixed(width)} ${fixed(height)} re f Q`);
    }

    function drawTableHeader() {
      const headerHeight = 24;
      drawFillRect(margin, y, tableRight - margin, headerHeight, "0.93 0.94 0.95");
      drawLine(margin, y, tableRight, y, 0.8);
      drawText("#", x.number, y - 16, 9, true);
      drawText("Item name", x.product, y - 16, 9, true);
      drawRightText("Unit cost", x.rate, y - 16, 9, true);
      drawRightText("Qty", x.qty, y - 16, 9, true);
      drawRightText("Line total", x.amount, y - 16, 9, true);
      y -= headerHeight;
      drawLine(margin, y, tableRight, y, 0.8);
    }

    newPage(false);
    drawCenteredText("Purchase Order", pageWidth / 2, y, 22, true);
    drawRightText(data.poNumber || "", tableRight, y, 12, true);
    y -= 38;

    drawText("From", margin, y, 9, true);
    drawText("Supplier", 238, y, 9, true);
    drawText("Date", 424, y, 9, true);
    y -= 16;
    drawText(data.from, margin, y, 12);
    drawText(data.supplier || "-", 238, y, 12);
    drawText(data.date, 424, y, 12);
    y -= 32;

    drawTableHeader();

    const items = data.items.length ? data.items : [{ number: 1, product: "", qty: 0, rate: 0, amount: 0 }];
    items.forEach((item, index) => {
      const titleLines = wrapPdfText(item.product || "", 54);
      const rowHeight = Math.max(30, titleLines.length * 12 + 18);
      ensureSpace(rowHeight, true);
      const textY = y - 18;

      drawText(String(index + 1), x.number, textY, 9);
      titleLines.forEach((line, lineIndex) => drawText(line, x.product, textY - lineIndex * 12, 9));
      drawRightText(formatMoney(item.rate), x.rate, textY, 9);
      drawRightText(item.qty ? String(item.qty) : "", x.qty, textY, 9);
      drawRightText(formatMoney(item.amount), x.amount, textY, 9);
      y -= rowHeight;
      drawLine(margin, y, tableRight, y, 0.35);
    });

    ensureSpace(98, false);
    y -= 22;
    const summaryLeft = tableRight - 170;
    drawLine(summaryLeft, y, tableRight, y, 0.8);
    y -= 22;
    drawText("Subtotal", summaryLeft, y, 10);
    drawRightText(formatMoney(data.subtotal), tableRight, y, 10);
    y -= 20;
    drawText("VAT", summaryLeft, y, 10);
    drawRightText(formatMoney(data.vat), tableRight, y, 10);
    y -= 22;
    drawText("Total", summaryLeft, y, 12, true);
    drawRightText(formatMoney(data.total), tableRight, y, 12, true);

    if (data.message) {
      ensureSpace(70, false);
      y -= 34;
      drawText("Message to supplier", margin, y, 10);
      y -= 14;
      wrapPdfText(data.message, 94).slice(0, 5).forEach((line) => {
        drawText(line, margin, y, 9);
        y -= 12;
      });
    }

    const objects = [null];
    objects.push("<< /Type /Catalog /Pages 2 0 R >>");
    objects.push("");
    objects.push("<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>");
    objects.push("<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>");

    const pageRefs = [];
    pages.forEach((content) => {
      const stream = content.join("\n");
      const contentId = objects.length;
      objects.push(`<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`);
      const pageId = objects.length;
      objects.push(
        `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${fixed(pageWidth)} ${fixed(pageHeight)}] /Resources << /Font << /F1 3 0 R /F2 4 0 R >> >> /Contents ${contentId} 0 R >>`
      );
      pageRefs.push(`${pageId} 0 R`);
    });

    objects[2] = `<< /Type /Pages /Kids [${pageRefs.join(" ")}] /Count ${pageRefs.length} >>`;

    let pdf = "%PDF-1.4\n";
    const offsets = [0];
    for (let id = 1; id < objects.length; id += 1) {
      offsets[id] = pdf.length;
      pdf += `${id} 0 obj\n${objects[id]}\nendobj\n`;
    }
    const xrefOffset = pdf.length;
    pdf += `xref\n0 ${objects.length}\n0000000000 65535 f \n`;
    for (let id = 1; id < objects.length; id += 1) {
      pdf += `${String(offsets[id]).padStart(10, "0")} 00000 n \n`;
    }
    pdf += `trailer\n<< /Size ${objects.length} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`;
    return pdf;
  }

  function downloadBlob(blob, filename) {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  }

  function makeFileName(data, extension) {
    const supplier = slug(data.supplier || "supplier");
    const reference = slug(data.poNumber || data.dateValue || "purchase-order");
    return `${reference}-${supplier}.${extension}`;
  }

  function generateReference() {
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const values = new Uint8Array(6);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(values);
    } else {
      for (let index = 0; index < values.length; index += 1) {
        values[index] = Math.floor(Math.random() * 256);
      }
    }
    return Array.from(values, (value) => alphabet[value % alphabet.length]).join("");
  }

  function clearOldDraft() {
    try {
      window.localStorage.removeItem("capital-drinks-purchase-order-v1");
    } catch (error) {
      return null;
    }
    return true;
  }

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function parseNumber(value) {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatNumber(value) {
    return Number(value || 0).toFixed(2);
  }

  function formatMoney(value) {
    return Number(value || 0).toLocaleString("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function formatDisplayDate(value) {
    if (!value) return "";
    const parts = value.split("-");
    if (parts.length !== 3) return value;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  function getLocalDateValue(date) {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate.toISOString().slice(0, 10);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function escapeXml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&apos;");
  }

  function slug(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 80);
  }

  function fixed(number) {
    return Number(number).toFixed(2);
  }

  function estimateTextWidth(text, size) {
    return String(text || "").length * size * 0.52;
  }

  function pdfEscape(value) {
    return String(value || "")
      .replace(/[^\x20-\x7e]/g, "?")
      .replace(/\\/g, "\\\\")
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)");
  }

  function wrapPdfText(value, limit) {
    const words = String(value || "").replace(/\s+/g, " ").trim().split(" ").filter(Boolean);
    const lines = [];
    let line = "";

    words.forEach((word) => {
      if (word.length > limit) {
        if (line) {
          lines.push(line);
          line = "";
        }
        let rest = word;
        while (rest.length > limit) {
          lines.push(rest.slice(0, limit));
          rest = rest.slice(limit);
        }
        line = rest;
        return;
      }

      if (!line) {
        line = word;
        return;
      }

      if (`${line} ${word}`.length <= limit) {
        line = `${line} ${word}`;
      } else {
        lines.push(line);
        line = word.slice(0, limit);
      }
    });

    if (line) lines.push(line);
    return lines.length ? lines : [""];
  }
})();
